import { useUserStore } from "./stores/userStore"
import { UserTicketsButtonView } from "react-ui-components/components/UserTicketsButtonView"
import ticketImage from "../assets/images/ticket-img-optimized.png"
import { immersivePopupStyle } from "../utils/popupStyles"
import { useNamespacedTranslation } from "../hooks/useNamespacedTranslation"
import { openTicketsPopup } from "../utils/lazyPopups"

export interface UsersCounterProps {
  style?: any
}

export const UsersTickets = function UsersCounter(props: UsersCounterProps) {
  const { isLoggedIn, ticketsCount } = useUserStore()
  const { t } = useNamespacedTranslation(["common"])

  if (!isLoggedIn) {
    return null
  }

  return (
    <UserTicketsButtonView
      iconAlt={t("Tickets")}
      iconSrc={ticketImage}
      value={ticketsCount}
      label={t("Tickets")}
      onClick={() => void openTicketsPopup(isLoggedIn, immersivePopupStyle)}
    />
  )

  // return (
  //   <Button
  //     variant="contained"
  //     style={$styles}
  //     className="flex flex-row gap-1/2 w-full"
  //     startIcon={
  //       <div className="flex flex-col gap-1 items-center">
  //         <div className="flex flex-row items-center">
  //           <Icon className="size-5 sm:size-6">{iconDefault.name}</Icon>
  //           <span className="ml-2 text-[16px]"> {formatCash(ticketsCount || 0)}</span>
  //         </div>

  //         <span className="text-[8px] sm:text-xs">Tickets</span>
  //       </div>
  //     }
  //     onClick={() => {
  //       isLoggedIn
  //         ? PopupService.setPopup(<Tickets />, "", {
  //             maxWidth: "100%",
  //             width: "100%",
  //             height: "100%",
  //           })
  //         : PopupService.setPopup(<Login />)
  //     }}
  //   ></Button>
  // )
}
